import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";
import CustomTable from "../../CustomTable.js";
import pricing from '../../../assets/Data/pricingData'


const fastertime = require("../../../assets/icons-pack/6.2 MySQL/ic_01_fastertime.svg");
const scalibility = require("../../../assets/icons-pack/6.2 MySQL/ic_02_scalibility.svg");
const costeffect = require("../../../assets/icons-pack/6.2 MySQL/ic_03_costeffect.svg");
const highavailiblity = require("../../../assets/icons-pack/6.2 MySQL/ic_04_highavailiblity.svg");
const flexibility = require("../../../assets/icons-pack/6.2 MySQL/ic_05_flexibility.svg");
const highavailibility = require("../../../assets/icons-pack/6.2 MySQL/ic_06_highavailibility.svg");
const optionalfeatures = require("../../../assets/icons-pack/6.2 MySQL/ic_07_optionalfeatures.svg");

const MySQL = () => {
    const heading = `MYSQL®`;
    const details = `Enterprise-ready, fully managed community MySQL. `;

    const overview = [
        `MySQL is the world's most popular open source relational database; DETASAD MySQL Database Service makes it easy to set up, operate, and scale MySQL deployments in the cloud. With DETASAD MySQL Database Service, you can deploy scalable MySQL servers in minutes with cost-effective and resizable infrastructure capacity. DETASAD MySQL Database Service supports different MySQL editions including MySQL Standard Edition, MySQL Enterprise Edition and MySQL Cluster CGE.`,
        `DETASAD MySQL Database Service gives you time to focus on application development by managing your database including provisioning, taking backup, patching, monitoring, and infrastructure scaling.`
    ];

    const advantages = [
        [
            `Faster Time `,
            `Accomplish faster time - to provision infrastructure for MySQL Server in hours versus weeks to months. `,
            fastertime
        ],
        [`Scalability`, `Scale infrastructure resources – as your data requirements. `, scalibility],
        [
            `Cost Effective `,
            `Decrease cost - by paying for only the infrastructure assets and resources that you need and use. `,
            costeffect
        ],
        [
            `Flexibility`,
            `Bring your own license – leverage your existing licensing investment with no extra licensing fees. Pay for the licenses monthly on leasing model. `,
            flexibility
        ],
        [
            `High Availability `,
            `DB Incident Management. Configuration Management. Patch management. Interfacing with Database vendors. DB security patches management in coordination with the Customer. `,
            highavailiblity
        ],
        [
            `Database Monitoring `,
            `Database processes. Database response time. 24x7x365 monitoring. Proactive notification `,
            highavailibility
        ]
    ];
    let TablesData = []
    pricing.map(price => {
        price.price = parseFloat(price.price).toFixed(2);
        if (price.name.includes('MySQL') && !price.name.includes('Bitnami')) {
            console.log(price, 'price')
            price['hourlyPricing'] = (price.price / 720).toFixed(2)
            price['monthlyPricing'] = price.price
            TablesData.push(price)
        }
    })

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-database"/>
            <SubNav
                overview={overview}
                advantages={advantages}
                // CustomTable={CustomTable}
                // TablesData={TablesData}
                // onlyMonthly
            />
            <Footer />
        </div>
    );
};

export default MySQL;
